export const isElectronTrayWindow = () => {
  return localStorage.getItem('isElectronTrayWindow') === 'true';
};
